import slugify from 'slugify';

export const generateCruiseUrl = (
    cruisePathPrefix: string,
    cruiseTitle: string,
    cruiseId: number,
    selectedSailId: number = 0,
): string => {
    if (!cruiseTitle || typeof cruiseTitle !== 'string') {
        // It's only needed cruise page prefix and the cruise id, so if the cruise title is not
        // there we can still create the url
        cruiseTitle = 'cruise';
    }

    const title = slugify(cruiseTitle, { lower: true }).replace(/[^a-z0-9- ]/g, '');

    return `/${cruisePathPrefix}/${title}-${cruiseId}${
        selectedSailId > 0 ? `#selectedSail=${selectedSailId}` : ''
    }`;
};
